import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { ThemeProvider } from '@bloo-team/ui'
import '@bloo-team/ui/styles.css'
import './styles/app.css'
// Side effect: the composer installs the product manifests into
// @bloo-team/core-shell's registry. Must run before anything renders.
import './product-registry'
import { createQueryClient } from './lib/query'
import { rewriteHashEntry } from './lib/hash-entry'
import { routeTree } from './routeTree.gen'

// Before the router exists: an inbound session handoff arrives as
// `/#/auth/handoff/<token>`, which a path-based router cannot see. Translating
// the fragment to a path first is what makes that link land on its route
// instead of on login (docs/session-handoff.md).
rewriteHashEntry()

const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('#root not found')

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={createQueryClient()}>
      <ThemeProvider>
        <RouterProvider router={router} />
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
)
